module.exports = "<div *ngIf=\"(recentPosts|async)?.length\" class=\"control-icon more has-items bg-comment ml-2\">\r\n    <i class=\"fa fa-comment fa-3x\" aria-hidden=\"true\"></i>\r\n    <div class=\"label-avatar\" (click)=\"loadRecentPosts()\">{{(recentPosts|async)?.length}}</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/recent-posts/recent-posts.component.html
// module id = ../../../../../src/app/recent-posts/recent-posts.component.html
// module chunks = main